const currencyDecimalFormatter = new Intl.NumberFormat('th', {
  style: 'decimal',
  currency: 'THB',
  maximumFractionDigits: 2,
  minimumFractionDigits: 0,
});

export default currencyDecimalFormatter;
